import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { activateModal, addHoveredProperty, clearHoveredProperty } from '../../store/actions';
import { saveBuilding, saveSite } from '../../store/actions/favorites';
import { PROPERTY_TYPES } from '../../constants';

import { ViewerPrimaryColorUserStyle } from '../UserCustomization';

import ListMedia from './ListMedia';
import ListItemSummary from './ListItemSummary';
import ListItemLinks from './ListItemLinks';

export class ListItemComponent extends React.Component {
  componentDidMount() {
    // We have to "steal" the close button of the popup and put it inside this component.
    // This is necessary for onMouseLeave not to trigger when hovering the close button.
    const popupContainer = this.domElement.closest('.leaflet-popup');
    if (!popupContainer) return;
    this.closeButton = popupContainer.getElementsByClassName('leaflet-popup-close-button')[0];
    if (!this.closeButton) return;
    this.domElement.appendChild(this.closeButton);
  }

  componentWillUnmount() {
    // We have to restore the close button or else it won't come back when opening the popup again
    if (this.closeButton) {
      this.domElement.closest('.leaflet-popup').appendChild(this.closeButton);
    }
  }

  render() {
    const {
      handleClick,
      handleSaveClick,
      onDemographicsClick,
      onAddToFavoritesClick,
      handleModalOpen,
      onVideoClick,
      property,
      type,
      handleMouseEnter,
      handleMouseLeave,
      saved,
      viewDetails,
      isHovered,
      isActive,
      organizationId,
      marker,
    } = this.props;

    return (
      <li
        onMouseEnter={() => { handleMouseEnter(property); }}
        onMouseLeave={() => { handleMouseLeave(); }}
        className={(isHovered || isActive) ? 'highlight' : ''}
        ref={e => { this.domElement = e; }}
      >
        <ListMedia
          type={type}
          property={property}
          handleClick={() => handleClick(property._id, property)}
          onVideoClick={onVideoClick}
          isActive={isActive}
          marker={marker}
        />
        <div className="list-col-2">
          <a tabIndex="0" className="list-text__link" onClick={() => { handleClick(property._id, property); }}>
            <ListItemSummary
              type={type}
              property={property}
            />
          </a>
          <ListItemLinks
            property={property}
            type={type}
            saved={saved}
            organizationId={organizationId}
            onDemographicsClick={onDemographicsClick}
            onAddToFavoritesClick={onAddToFavoritesClick}
            handleModalOpen={handleModalOpen}
            handleSaveClick={handleSaveClick}
          />
          {viewDetails &&
            <ViewerPrimaryColorUserStyle domStyle="color">
              <a className="list-view-details" tabIndex="0" onClick={() => { handleClick(property._id); }}>
                View Details
              </a>
            </ViewerPrimaryColorUserStyle>
          }
        </div>
      </li>
    );
  }
}

ListItemComponent.propTypes = {
  property: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleSaveClick: PropTypes.func.isRequired,
  onDemographicsClick: PropTypes.func.isRequired,
  onAddToFavoritesClick: PropTypes.func.isRequired,
  onVideoClick: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
  saved: PropTypes.bool.isRequired,
  viewDetails: PropTypes.bool,
  isHovered: PropTypes.bool,
  isActive: PropTypes.bool,
  organizationId: PropTypes.string,
  marker: PropTypes.bool,
};

/* istanbul ignore next */
function mapStateToProps({
  favorites,
  hoveredProperty,
  buildings,
  sites,
  organizationId,
  profile,
}, { type, property }) {
  const activeProperty = (type === PROPERTY_TYPES.BUILDINGS ? buildings : sites).active;
  return {
    // If any of the folders have this property, marked it as saved
    saved: favorites.folders.savedFolders.some(folder => (folder[type] &&
      folder[type].indexOf(property._id) !== -1)),
    isHovered: hoveredProperty._id === property._id,
    isActive: activeProperty.id === property._id,
    organizationId,
    dontShowAgain: favorites.dontShow,
    authenticated: profile.authenticated,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch, { type, handleClick }) {
  const saver = type === PROPERTY_TYPES.BUILDINGS ? saveBuilding : saveSite;
  return {
    handleClick: (id, property) => {
      let propertyName = '';
      let suite = null;
      let unit = null;
      if (property.name) {
        propertyName = property.name;
      } else if (property['basicInfo.name']) {
        propertyName = property['basicInfo.name'];
      }
      if (property['basicInfo.location.suite']) {
        suite = property['basicInfo.location.suite'];
      }
      if (property.unit) {
        unit = property.unit;
      }
      if (suite || unit) {
        propertyName += ` Suite ${suite || unit}`;
      }
      propertyName = propertyName.trim().replaceAll(' ', '-');
      dispatch(push(`/${type}/${id}/${encodeURIComponent(propertyName)}${window.location.search}`));
      if (handleClick) {
        handleClick(id);
      }
    },
    handleMouseEnter: property => dispatch(addHoveredProperty(property)),
    handleMouseLeave: () => dispatch(clearHoveredProperty()),
    onDemographicsClick: () => { dispatch(activateModal('report')); },
    activateFavoriteModal: () => { dispatch(activateModal('folders')); },
    onVideoClick: id => { dispatch(activateModal(`video-${id}`)); },
    handleSaveClick: id => { dispatch(saver(id)); },

    // Team LOIS has requested the functionality for notifying a user they are not logged
    // into favorites be removed for now. The functionality will be commented out for when
    // they as to have it re-implemented.

    // activateFavoriteModal: whichModal => { dispatch(activateModal(whichModal)); },
  };
}

function mergeProps(propsFromState, propsFromDispatch, ownProps) {
  // const checkValue =
  //   (propsFromState.authenticated || propsFromState.dontShowAgain || propsFromState.saved);
  return {
    // onAddToFavoritesClick: () =>
    //   (checkValue
    //     ? propsFromDispatch.activateFavoriteModal('folders')
    //     : propsFromDispatch.activateFavoriteModal('first-time')),
    onAddToFavoritesClick: () => {
      propsFromDispatch.activateFavoriteModal('folders');
    },
    ...propsFromDispatch,
    ...propsFromState,
    ...ownProps,
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ListItemComponent);



// WEBPACK FOOTER //
// ./src/components/List/ListItem.js